import {
  ListTodoIcon,
  BookIcon,
  UsersIcon,
  SettingsIcon,
  ChevronDown,
  UsersRoundIcon,
  CopyCheckIcon,
  LayoutTemplateIcon,
  HomeIcon,
} from "lucide-react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router";
import { useState } from "react";
import { selectUserSignedIn } from "app/slices/user/userSlice";
// sidebar item

const commonSidebarStyles = (
  enabled,
  active
) => `px-3 py-2 w-full inline-flex justify-start items-center gap-2 rounded-lg
    text-sm font-medium leading-tight tracking-tight  
      ${active ? "bg-background-active text-text-primary" : "hover:bg-background-primary"}
      ${
        enabled ? "text-text-primary" : "text-text-disabled pointer-events-none"
      }`;

function SidebarItem({ Icon, enabled, children, to = "", active = false }) {
  return (
    <Link to={to} className={commonSidebarStyles(enabled, active)}>
      {<Icon size={16} strokeWidth={1.5} />}
      {children}
    </Link>
  );
}

function SettingsItem({ enabled, active = false, isOpen, onToggle }) {
  return (
    <>
      <button
        onClick={onToggle}
        className={`hs-collapse-toggle ${commonSidebarStyles(enabled, active)}`}
      >
        {<SettingsIcon size={16} strokeWidth={1.5} />} Settings{" "}
        <ChevronDown
          size={16}
          strokeWidth={1.5}
          className={`transition-transform ${isOpen ? "-rotate-90" : ""}`}
        />
      </button>
    </>
  );
}

export default function Sidebar() {
  // depends on permissions, move this to a UI slice
  const enabled = useSelector(selectUserSignedIn);
  const location = useLocation();
  const [settingsOpen, setSettingsOpen] = useState(false);

  // Determine active tab based on current location
  const isHome = location.pathname === "/";
  const isCyclicalReviews = location.pathname === "/reviews/cyclical";
  const isNewReviews = location.pathname === "/reviews/new";
  const isReports = location.pathname === "/reports";
  const isSettings = location.pathname.startsWith("/settings");
  const isUserSettings = location.pathname.startsWith("/settings/users");
  const isPermissionsSettings = location.pathname.startsWith("/settings/permissions");
  const isDashboardSettings = location.pathname.startsWith("/settings/dashboard");

  // Auto-open settings when navigating to settings page
  /*if (isSettings && !settingsOpen) {
    setSettingsOpen(true);
  }*/

  return (
    <div className="w-64 self-stretch px-2.5 py-7 bg-background-secondary inline-flex flex-col justify-start items-start gap-2.5 overflow-hidden flex-shrink-0">
      <SidebarItem Icon={HomeIcon} enabled={enabled} to={""} active={isHome}>
        Home
      </SidebarItem>
      <SidebarItem
        Icon={ListTodoIcon}
        enabled={enabled}
        to="/reviews/cyclical"
        active={isCyclicalReviews}
      >
        Cyclical Program Reviews
      </SidebarItem>
      <SidebarItem
        Icon={BookIcon}
        enabled={enabled}
        to="/reviews/new"
        active={isNewReviews}
      >
        New Program Reviews
      </SidebarItem>
      <SidebarItem Icon={UsersIcon} enabled={enabled} to={"/reports"} active={isReports}>
        Reports
      </SidebarItem>

      {/* settings is collapsable */}
      <SettingsItem
        enabled={enabled}
        active={isSettings}
        isOpen={settingsOpen}
        onToggle={() => setSettingsOpen(!settingsOpen)}
      />
      <div
        className={`w-full overflow-hidden transition-all duration-300 ${
          settingsOpen ? "max-h-96" : "max-h-0"
        }`}
      >
        <div className="pl-7">
          <SidebarItem
            Icon={UsersRoundIcon}
            enabled={enabled}
            to="/settings/users"
            active={isUserSettings}
          >
            Users
          </SidebarItem>
          <SidebarItem
            Icon={CopyCheckIcon}
            enabled={enabled}
            to="/settings/permissions"
            active={isPermissionsSettings}
          >
            Permissions
          </SidebarItem>
          <SidebarItem
            Icon={LayoutTemplateIcon}
            enabled={enabled}
            to="/settings/dashboard"
            active={isDashboardSettings}
          >
            Dashboard
          </SidebarItem>
        </div>
      </div>
    </div>
  );
}
